// extracted by mini-css-extract-plugin
module.exports = {"character":"character2_character__6kneW","swiper":"character2_swiper__AoPJR"};